// @ts-check
import { Trans } from '@lingui/macro';
import { useHistory } from 'react-router-dom';
import Footer, {
  BackButton,
  CancelButton,
  NextButton,
} from '../../../../components/Layout/Footer';
import Layout from '../../../../components/Layout/Layout';
import Main from '../../../../components/Layout/Main';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../../../components/Layout/PageHeader';
import ReviewImport, {
  useReviewImport,
} from '../../../../components/Review/partnerAliasImport/ReviewImport';
import { ProgressIndicator, useLink } from './_config';

export default function Review({ match }) {
  const link = useLink('review');
  const history = useHistory();
  const { workspaceId, importId } = match.params;
  const props = useReviewImport({ workspaceId, importId });

  async function handleSubmit() {
    history.push(link.next());
  }

  return (
    <Layout>
      <ProgressIndicator step="ready" />
      <PageHeader>
        <PageTitle>
          <Trans>Review changes</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>
            Preview how each line of the source file will be processed.
          </Trans>
        </PageSubtitle>
      </PageHeader>

      <Main>
        <ReviewImport {...props} />
      </Main>

      <Footer>
        <BackButton to={link.back()} />
        <CancelButton to={link.cancel()} />
        <NextButton onClick={handleSubmit} />
      </Footer>
    </Layout>
  );
}
